function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "resistor");

var SvgResistor = function SvgResistor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bef77a3c-9eb7-4760-b50a-e451583dc14b",
    "data-name": "Capa 1",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M366.52,160.34a15.13,15.13,0,0,1-10.59-25.93L486.28,6.61a15.13,15.13,0,0,1,21.18,21.6L377.11,156A15.08,15.08,0,0,1,366.52,160.34Z",
    style: {
      fill: "#9ca2b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.23,156.28,506.64,5.87a15.12,15.12,0,0,0-20.36.74L355.93,134.41a15.12,15.12,0,0,0-.21,21.39C355.88,156,356.06,156.12,356.23,156.28Z",
    style: {
      fill: "#cdd2e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.13,509.72a15.13,15.13,0,0,1-10.6-25.93L115.44,374.9a15.13,15.13,0,1,1,21.2,21.59L25.73,505.38A15.06,15.06,0,0,1,15.13,509.72Z",
    style: {
      fill: "#9ca2b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93,506.58,137.11,375.4l-.27-.31a15.13,15.13,0,0,0-21.4-.19L4.53,483.79a15.14,15.14,0,0,0-.2,21.4A17.3,17.3,0,0,0,5.93,506.58Z",
    style: {
      fill: "#cdd2e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.53,192c-2-10.74-7.53-19.45-13.21-27.26a252.7,252.7,0,0,0-52-52.94c-11.5-8.71-29.12-19.83-49.13-16-39.93,7.69-56.24,54-61.59,69.22h0A69.06,69.06,0,0,1,236,174c-4.34,8-38.45,40.1-54.84,55.52-7.73,7.27-14.41,13.55-18.39,17.52a13,13,0,0,1-5.12,3.16l-12.73,4.23c-26.41,8.76-64.21,36.69-65.55,71.37-.64,16.46,6.88,30.66,12.59,39.92a164.32,164.32,0,0,0,57.85,56.05c8.45,4.85,20.91,11,35.11,11a47.25,47.25,0,0,0,4.87-.24c32.71-3.33,59.22-40.38,67.59-65.62h0l4.22-12.72a13.19,13.19,0,0,1,3.16-5.13l72.34-72.33,9.78-3.24C374.13,264.38,423.63,235.71,415.53,192Z",
    style: {
      fill: "#f2c275"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.26,396.24,377.2,135.3a251.87,251.87,0,0,0-26.84-23.46c-11.5-8.71-29.12-19.83-49.13-16-39.93,7.69-56.24,54-61.59,69.22h0A69.06,69.06,0,0,1,236,174c-4.34,8-38.45,40.1-54.84,55.52-7.73,7.27-14.41,13.55-18.39,17.52a13,13,0,0,1-5.12,3.16l-12.73,4.23c-26.41,8.76-64.21,36.69-65.55,71.37-.64,16.46,6.88,30.66,12.59,39.92A164,164,0,0,0,116.26,396.24Z",
    style: {
      fill: "#ffde91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,318.72l-21.39,21.39L171.78,238.28c1.11-1.05,19.91-18.75,22-20.76Z",
    style: {
      fill: "#f9aa1e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.4,268.11l-50.59-50.59c-2.12,2-20.92,19.71-22,20.76L223,289.5Z",
    style: {
      fill: "#ffd039"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.18,274.65c-1.92.63-4.26,1.4-6.13,2L319.74,294,218.86,193.18c4-4,7.6-7.75,10.48-10.92A54.08,54.08,0,0,0,236,174c.73-1.39,1.41-2.92,2-4.47Z",
    style: {
      fill: "#2864f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.51,222,238,169.51c-.63,1.55-1.31,3.08-2,4.47a54.08,54.08,0,0,1-6.61,8.28c-2.88,3.17-6.49,6.9-10.48,10.92l50.25,50.22Z",
    style: {
      fill: "#3389ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.91,240.19a96.78,96.78,0,0,1-11,10.36,123.32,123.32,0,0,1-12.52,8.88l-123.8-123.8c1.49-2.66,3.14-5.34,4.92-8,1.12-1.67,2.31-3.32,3.54-5a86.06,86.06,0,0,1,10.18-11.22Z",
    style: {
      fill: "#5dc694"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.11,176.39l-64.92-64.92A86.06,86.06,0,0,0,261,122.69c-1.23,1.64-2.42,3.29-3.54,5-1.78,2.64-3.43,5.32-4.92,8l62.16,62.16Z",
    style: {
      fill: "#95e8c8"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResistor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resistor.e192016a.svg";
export { ForwardRef as ReactComponent };